import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useEffect, useState } from "react";
import ReactOwlCarousel from "react-owl-carousel";
import styles from "./PromoBanner.module.css";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../store";
import { PromoBannerLoader } from "../Loader/Loader";
// Import JsonLd from react-schemaorg
import { JsonLd } from "react-schemaorg";

export const PromoBanner = ({ type }) => {
  const [loading, setLoading] = useState(true);
  const promoBanners = useAppStore((state) => state.promoBanners);
  const offerBanners = useAppStore((state) => state.offerBanners);
  const [allBanner, setAllBanner] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (type === "Promo Banner") {
      setAllBanner(promoBanners);
      setLoading(false);
    } else if (type === "Offers") {
      setAllBanner(offerBanners);
      setLoading(false);
    }
  }, [promoBanners, offerBanners]);

  const redirectToLink = (item) => {
    if (item?.site_link) {
      if (window !== undefined) window.open(item?.site_link, "_blank");
    } else if (item?.category_id && item?.vertical_id) {
      navigate(
        `/store-product/vertical/${item?.vertical_name_url}/category/${item?.category_name_url}`
      );
    } else if (item?.product_id) {
      navigate(`/product/${item?.product_name_url}/${item?.product_id}`);
    }
  };

  return (
    <>
      {/* ItemList Schema for Promo Banners */}
      {allBanner?.length > 0 && (
        <JsonLd
          item={{
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: type === "Promo Banner" ? "Promotional Banners" : "Offer Banners",
            description: `A collection of ${type === "Promo Banner" ? "promotional" : "offer"} banners showcasing special deals and products.`,
            url: window.location.href,
            itemListElement: allBanner.map((item, index) => {
              let itemUrl = item?.site_link
                ? item.site_link
                : item?.product_id
                  ? `${window.location.origin}/product/${item.product_name_url}/${item.product_id}`
                  : item?.category_id && item?.vertical_id
                    ? `${window.location.origin}/store-product/vertical/${item.vertical_name_url}/category/${item.category_name_url}`
                    : "";

              return {
                "@type": "ListItem",
                position: index + 1,
                item: {
                  "@type": "Offer", // Could also use "Product" or "CreativeWork" depending on context
                  name: item?.name || "Banner Promotion",
                  image: item?.image || "",
                  url: itemUrl,
                  description: `Promotion for ${item?.name || "a special offer"}`,
                },
              };
            }),
          }}
        />
      )}

      <div style={{
        borderTop: type === "Promo Banner" ? "5px solid var(--PRIMARY_COLOR)" : "none",
        borderBottom: type === "Promo Banner" ? "5px solid var(--PRIMARY_COLOR)" : "none",
        marginTop: type === "Promo Banner" ? "30px" : "0px",
        marginBottom: type === "Promo Banner" ? "30px" : "0px",
      }}>
        <div className="container">
          {loading ? (
            <PromoBannerLoader />
          ) : (
            <div>
              {allBanner?.length > 0 && (
                <div className={`col-12 d-inline-flex p-0 flex-column mt-2`}>
                  <div className="container-fluid p-0">
                    <div className={`col-12 d-inline-flex flex-column`}>
                      {allBanner.length === 1 ? (
                        // Single banner view without carousel
                        <div
                          onClick={() => redirectToLink(allBanner[0])}
                          className={`${styles.promoBanner}`}
                          style={{
                            cursor: "pointer",
                            maxWidth: "100%",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={allBanner[0]?.image}
                            alt={allBanner[0]?.name}
                            className="col-12 d-inline-block"
                            style={{
                              borderRadius: "0px !important",
                            }}
                          />
                        </div>
                      ) : (
                        // Carousel view for multiple banners
                        <ReactOwlCarousel
                          className={`${styles.bannerContainer} brandSilder col-12 d-inline-block owl-theme`}
                          margin={10}
                          nav={true}
                          loop={true}
                          dots={false}
                          responsive={{
                            0: { items: 1.2 },
                            700: { items: type === "Promo Banner" ? 1.2 : 2 },
                            1000: { items: type === "Promo Banner" ? 1.2 : 2.5 },
                            1300: { items: type === "Promo Banner" ? 1.2 : 3 },
                          }}
                          stagePadding={0}
                        >
                          {allBanner.map((item, index) => {
                            return (
                              <div
                                onClick={() => redirectToLink(item)}
                                key={index}
                                className={`${styles.promoBanner}`}
                                style={{
                                  cursor: "pointer",
                                  maxWidth: "100%",
                                  overflow: "hidden",
                                }}
                              >
                                <img
                                  src={item?.image}
                                  alt={item?.name}
                                  className="col-12 d-inline-block"
                                  style={{
                                    // height: "38rem",
                                    borderRadius: "0px !important",
                                  }}
                                />
                              </div>
                            );
                          })}
                        </ReactOwlCarousel>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};